// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   OAuth Callback 2026 — MCP / 외부 서비스 OAuth 콜백 수신 페이지
   forgot2026 / signup2026 디자인 시스템과 동일한 토큰 사용
   ============================================================ */

.oauth2026 {
    min-height: 100vh;
    background: #fff;
    font-family: var(--font-sans, 'Pretendard', sans-serif);
    color: var(--fg-text-basic);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 24px 32px;
    box-sizing: border-box;
}

.oauth2026__main {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 32px;
    flex: 1 1;
}

/* ─── 브랜드 ─── */
.oauth2026__brand {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 42px;
}

.oauth2026__brand-logo {
    width: 38px;
    height: 42px;
    object-fit: contain;
    display: block;
}

.oauth2026__brand-text {
    font-family: 'Pretendard', sans-serif;
    font-size: 26px;
    font-weight: 800;
    color: var(--fg-text-basic);
    letter-spacing: -0.6px;
    line-height: 1;
}

/* ─── 섹션 ─── */
.oauth2026__section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    width: 100%;
}

/* ─── 상태 아이콘 ─── */
.oauth2026__indicator {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
}

.oauth2026__indicator--success {
    background: var(--fg-button);
}

.oauth2026__indicator--error {
    background: var(--fg-anti-red, #ff1500);
}

.oauth2026__indicator--unknown {
    background: var(--fg-text-gray);
}

.oauth2026__spinner-svg {
    animation: oauth2026-spin 0.9s linear infinite;
}

@keyframes oauth2026-spin {
    to { transform: rotate(360deg); }
}

/* ─── 타이틀 / 설명 ─── */
.oauth2026__title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.2px;
    color: var(--fg-text-basic);
}

.oauth2026__desc {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--fg-text-gray);
    white-space: pre-line;
    word-break: keep-all;
}

.oauth2026__hint {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    color: var(--fg-text-gray);
}

/* ─── 액션 ─── */
.oauth2026__actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
}

.oauth2026__submit {
    width: 100%;
    min-height: 44px;
    padding: 12px;
    background: var(--fg-button);
    border: 0;
    border-radius: 8px;
    color: #fff;
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    transition: background 160ms ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    text-align: center;
    box-sizing: border-box;
}

.oauth2026__submit:hover:not(:disabled) {
    background: var(--fg-button-hover);
}

.oauth2026__submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.oauth2026__link-btn {
    color: var(--fg-link, #2c95f8);
    text-decoration: underline;
    font-weight: 600;
    background: transparent;
    border: 0;
    padding: 4px 0;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;
    transition: color 160ms ease;
    text-align: center;
}

.oauth2026__link-btn:hover:not(:disabled) {
    color: var(--fg-link-hover, #1a7ad6);
}

.oauth2026__link-btn:disabled {
    color: var(--fg-text-gray);
    cursor: not-allowed;
    text-decoration: none;
}

`, "",{"version":3,"sources":["webpack://./src/css/OAuthCallback.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uDAAuD;IACvD,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,SAAO;AACX;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,qBAAqB;AACrB;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;AACzB","sourcesContent":["/* ============================================================\n   OAuth Callback 2026 — MCP / 외부 서비스 OAuth 콜백 수신 페이지\n   forgot2026 / signup2026 디자인 시스템과 동일한 토큰 사용\n   ============================================================ */\n\n.oauth2026 {\n    min-height: 100vh;\n    background: #fff;\n    font-family: var(--font-sans, 'Pretendard', sans-serif);\n    color: var(--fg-text-basic);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 48px 24px 32px;\n    box-sizing: border-box;\n}\n\n.oauth2026__main {\n    width: 100%;\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 32px;\n    flex: 1;\n}\n\n/* ─── 브랜드 ─── */\n.oauth2026__brand {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    height: 42px;\n}\n\n.oauth2026__brand-logo {\n    width: 38px;\n    height: 42px;\n    object-fit: contain;\n    display: block;\n}\n\n.oauth2026__brand-text {\n    font-family: 'Pretendard', sans-serif;\n    font-size: 26px;\n    font-weight: 800;\n    color: var(--fg-text-basic);\n    letter-spacing: -0.6px;\n    line-height: 1;\n}\n\n/* ─── 섹션 ─── */\n.oauth2026__section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 16px;\n    width: 100%;\n}\n\n/* ─── 상태 아이콘 ─── */\n.oauth2026__indicator {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 8px 0;\n}\n\n.oauth2026__indicator--success {\n    background: var(--fg-button);\n}\n\n.oauth2026__indicator--error {\n    background: var(--fg-anti-red, #ff1500);\n}\n\n.oauth2026__indicator--unknown {\n    background: var(--fg-text-gray);\n}\n\n.oauth2026__spinner-svg {\n    animation: oauth2026-spin 0.9s linear infinite;\n}\n\n@keyframes oauth2026-spin {\n    to { transform: rotate(360deg); }\n}\n\n/* ─── 타이틀 / 설명 ─── */\n.oauth2026__title {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32px;\n    letter-spacing: -0.2px;\n    color: var(--fg-text-basic);\n}\n\n.oauth2026__desc {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: var(--fg-text-gray);\n    white-space: pre-line;\n    word-break: keep-all;\n}\n\n.oauth2026__hint {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.4;\n    color: var(--fg-text-gray);\n}\n\n/* ─── 액션 ─── */\n.oauth2026__actions {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 8px;\n}\n\n.oauth2026__submit {\n    width: 100%;\n    min-height: 44px;\n    padding: 12px;\n    background: var(--fg-button);\n    border: 0;\n    border-radius: 8px;\n    color: #fff;\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 160ms ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    text-align: center;\n    box-sizing: border-box;\n}\n\n.oauth2026__submit:hover:not(:disabled) {\n    background: var(--fg-button-hover);\n}\n\n.oauth2026__submit:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.oauth2026__link-btn {\n    color: var(--fg-link, #2c95f8);\n    text-decoration: underline;\n    font-weight: 600;\n    background: transparent;\n    border: 0;\n    padding: 4px 0;\n    font-family: inherit;\n    font-size: 14px;\n    line-height: 1.4;\n    cursor: pointer;\n    transition: color 160ms ease;\n    text-align: center;\n}\n\n.oauth2026__link-btn:hover:not(:disabled) {\n    color: var(--fg-link-hover, #1a7ad6);\n}\n\n.oauth2026__link-btn:disabled {\n    color: var(--fg-text-gray);\n    cursor: not-allowed;\n    text-decoration: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
